import { ActionType, SaveDataType } from 'Types/common';
import * as types from './types';

export const getStateAction = ({ stage, data, next }: SaveDataType): ActionType<SaveDataType> => ({
  type: types.SAVE_USER_DATA_TYPE,
  payload: { stage, data, next },
});

export const setStageAction = (stage: string): ActionType<string> => ({
  type: types.SET_STAGE_TYPE,
  payload: stage,
});
